import type * as React from 'react';
import { getFile } from '@Domain/Api';
import auditTrailExported, {
	type AuditTrailExportedAction,
} from '@Application/AuditTrail/Actions/auditTrailExported';
import auditTrailExportFailed, {
	type AuditTrailExportFailedAction,
} from '@Application/AuditTrail/Actions/auditTrailExportFailed';
import type ExportAuditTrail from '@Application/AuditTrail/Queries/ExportAuditTrail';
import { downloadBlob } from '@Infra/Download';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = AuditTrailExportedAction | AuditTrailExportFailedAction;

export default (query: ExportAuditTrail) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const url = `${parameters.api.host}/api/accounts/${query.accountId}/audit-entries/export?${query.toQueryString()}`;

			const { blob, filename } = await getFile(url);
			downloadBlob(blob, filename ?? query.fallbackFilename);

			const action = auditTrailExported();
			dispatch(action);
			return action;
		} catch (error) {
			const action = auditTrailExportFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
